var utils = {
    /*
     * 获取试题的作答答案信息
     */
    getDoQuestionAnwerInfo:function(questionInfo,doQuestionInfo){
        var toHtData = {};
        var eqType = questionInfo.eqType;
        //获取做题的结果信息
        if(eqType == 4 || eqType == 10) {//填空题、匹配题(如果选项为空，则自动补为"")
            if(doQuestionInfo.eqAnswer) {
            for (let index = 0; index < doQuestionInfo.eqAnswer.length; index++) {
                const element = doQuestionInfo.eqAnswer[index];
                if(element == null) {
                doQuestionInfo.eqAnswer[index] = "";
                }
            }
            }
        }
        toHtData.eqAnswer = (doQuestionInfo.eqAnswer?doQuestionInfo.eqAnswer:"");
        if(eqType == 16) {
            var eqAnswerNew = [];
            if(toHtData.eqAnswer == "") {
                var eqAnswerArr = [];
                questionInfo.eqOtherInfo_16.forEach((elementAAA,indexAAA) => {
                    eqAnswerArr.push([]);
                });
                toHtData.eqAnswer = eqAnswerArr;
            }
            toHtData.eqAnswer.forEach((element,index) => {
                console.log("element=====================",element,typeof(element));
                if(typeof(element) == "object") {
                    eqAnswerNew.push(element.join(","));
                } else {
                    eqAnswerNew.push(element);
                }
            });
            toHtData.eqAnswer = eqAnswerNew;
        }
        if(eqType == 14) {//长难句(如果选项为空，则自动补为"")
            if(doQuestionInfo.eqAnswer1) {
                for (let index = 0; index < doQuestionInfo.eqAnswer1.length; index++) {
                    const element = doQuestionInfo.eqAnswer1[index];
                    if(element == null) {
                    doQuestionInfo.eqAnswer1[index] = "";
                    }
                }
            }
        }
        
        toHtData.eqAnswer1 = (doQuestionInfo.eqAnswer1?doQuestionInfo.eqAnswer1:"");

        if(eqType == 9) {
            //判断如果试题类型为 阅读题 则获取阅读题子试题的答案信息
            var ydToHtData = this.getYdDoQuestion(questionInfo,doQuestionInfo);
            for (var ydKey in ydToHtData) {
                toHtData[ydKey] = ydToHtData[ydKey];
            }
        } else if(eqType == 14) {
            //如果试题题型为 长难句
            toHtData.eqOption = (doQuestionInfo.eqOption?doQuestionInfo.eqOption:[]);
        }

        //获取批改信息
        //对错
        toHtData.IF_RIGHT = (doQuestionInfo.IF_RIGHT?doQuestionInfo.IF_RIGHT:"");
        //得分
        toHtData.GET_SCORE = (doQuestionInfo.GET_SCORE?doQuestionInfo.GET_SCORE:"");
        //点评：客观题的试题解析自动赋值到点评上
        if(eqType == 1 || eqType == 2 || eqType == 3 || eqType == 10 || eqType == 14) {
            if(doQuestionInfo.CHECK_REMARK && doQuestionInfo.CHECK_REMARK.length > 0) {
                toHtData.CHECK_REMARK = (doQuestionInfo.CHECK_REMARK?doQuestionInfo.CHECK_REMARK:"");
            } else {
                toHtData.CHECK_REMARK = (questionInfo.eqResolve?questionInfo.eqResolve:"");
            }
        }else {
            toHtData.CHECK_REMARK = (doQuestionInfo.CHECK_REMARK?doQuestionInfo.CHECK_REMARK:"");
        }
        //试卷中试题的分值信息
        toHtData.EPQ_SCORE = questionInfo.eqScore;

        if(eqType == 7) {
            //简答题 看是否有附件信息 如果有 进行后台传递
            var eqAnswerFileAddress = [];
            var eqAnswerFileType = [];
            var eqAnswerFile = doQuestionInfo.eqAnswerFile;
            if(eqAnswerFile) {
            eqAnswerFile.forEach(element => {
                eqAnswerFileAddress.push(element.downAddress);
                eqAnswerFileType.push(element.fileType);
            });
            }
            toHtData.eqAnswerFileAddress = eqAnswerFileAddress;
            toHtData.eqAnswerFileType = eqAnswerFileType;
        }
        return toHtData;
    },
    /**
     * 获取阅读题的子题的需要保存的信息
     */
    getYdDoQuestion:function(questionInfo,doQuestionInfo){
        var questionId = questionInfo.eqId;
        var toHtData = {};
        var childQuestionInfoList = questionInfo.childQuestionInfoList;
        toHtData["childQuestion_" + questionId] = childQuestionInfoList.length;
        //试题主键
        toHtData["questionId_" + questionId] = [];
        //学员试题主键
        toHtData["studentQuestionId_" + questionId] = [];
        //阅读题子题的分数
        toHtData["EPQ_SCORE_"+questionId] = [];
        
        //对错
        toHtData["IF_RIGHT_"+questionId] = [];
        //得分
        toHtData["GET_SCORE_"+questionId] = [];
        //点评
        toHtData["CHECK_REMARK_"+questionId] = [];
        if(childQuestionInfoList) {
            childQuestionInfoList.forEach((childQuestionInfo,questionIndex) => {
            var oneQuestionId = childQuestionInfo.eqId;
            var oneStudentQuestionId = doQuestionInfo.eqAnswer[questionIndex];
            var childDoquestionInfo = doQuestionInfo.childStuAnswerList[questionIndex];
            toHtData["questionId_" + questionId].push(oneQuestionId);
            toHtData["studentQuestionId_" + questionId].push(oneStudentQuestionId);
            var oneQuestionInfo = this.getDoQuestionAnwerInfo(childQuestionInfo,childDoquestionInfo);
            console.log("oneQuestionInfo==================================",oneQuestionInfo);
            toHtData["eqOption_" + questionId + "_" + questionIndex] = oneQuestionInfo.eqOption;
            toHtData["eqAnswer_" + questionId + "_" + questionIndex] = oneQuestionInfo.eqAnswer;
            toHtData["eqAnswer1_" + questionId + "_" + questionIndex] = oneQuestionInfo.eqAnswer1;
            toHtData["eqAnswerFileAddress_" + questionId + "_" + questionIndex] = oneQuestionInfo.eqAnswerFileAddress;
            toHtData["eqAnswerFileType_" + questionId + "_" + questionIndex] = oneQuestionInfo.eqAnswerFileType;
            console.log("EPQ_SCORE_===========================" + oneQuestionInfo.EPQ_SCORE);
            toHtData["EPQ_SCORE_" + questionId].push(oneQuestionInfo.EPQ_SCORE);

            toHtData["IF_RIGHT_" + questionId].push(oneQuestionInfo.IF_RIGHT);
            toHtData["GET_SCORE_" + questionId].push(oneQuestionInfo.GET_SCORE);
            toHtData["CHECK_REMARK_" + questionId].push(oneQuestionInfo.CHECK_REMARK);
            });
        }
        return toHtData;
    }
}

export default utils;